var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-field',{attrs:{"label":"Application","styles":"width: 140px;margin:0 -5px;","name":"app_id","placeholder":"choose app","type":"select","list":_vm.app_list,"display":_vm.display}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ed54a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/filterFieldApplications.vue
// module id = null
// module chunks = 